// src/CheckedIcon.tsx
import { jsx } from "react/jsx-runtime";
var CheckedIcon = ({ ...props }) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: "21",
    height: "21",
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M10.6509 0.208984C5.14088 0.208984 0.650879 4.69898 0.650879 10.209C0.650879 15.719 5.14088 20.209 10.6509 20.209C16.1609 20.209 20.6509 15.719 20.6509 10.209C20.6509 4.69898 16.1609 0.208984 10.6509 0.208984ZM15.4309 7.90898L9.76088 13.579C9.62088 13.719 9.43088 13.799 9.23088 13.799C9.03088 13.799 8.84088 13.719 8.70088 13.579L5.87088 10.749C5.58088 10.459 5.58088 9.97898 5.87088 9.68898C6.16088 9.39898 6.64088 9.39898 6.93088 9.68898L9.23088 11.989L14.3709 6.84898C14.6609 6.55898 15.1409 6.55898 15.4309 6.84898C15.7209 7.13898 15.7209 7.60898 15.4309 7.90898Z",
        fill: "currentColor"
      }
    )
  }
);
var CheckedIcon_default = CheckedIcon;

export {
  CheckedIcon_default
};
